import { http } from '../api/http';

export type DevelopmentBlock = {
  id: number;
  development_id: number;
  description?: string | null;
  unit_price: number;
  available_qty: number;
};

export type UpsertBlockPayload = {
  description?: string;
  unit_price: number;
  available_qty: number;
};

export const DevelopmentBlocksService = {
  list(developmentId: number | string) {
    return http<{ ok: boolean; data: DevelopmentBlock[] }>(`/admin/developments/${developmentId}/blocks`);
  },

  upsertDefault(developmentId: number | string, payload: UpsertBlockPayload) {
    return http<{ ok: boolean; data: DevelopmentBlock }>(`/admin/developments/${developmentId}/blocks/default`, {
      method: 'PUT',
      body: payload
    });
  }
};
